import axios from 'axios'
import {ApiResponse} from '../models/Base'
import { LeaderBoardDto, TableDto } from '../models/dto/SelfAssessment'
const API_URL = process.env.REACT_APP_API_URL
const ACTION_API_URL = `${API_URL}/summary`

export function GetLeaderBoard(seasonId:number) {
    return axios.get<ApiResponse<LeaderBoardDto>>(`${ACTION_API_URL}/leader-boards/${seasonId}`)
}

export function GetLastAssess() {
    return axios.get<ApiResponse<TableDto>>(`${ACTION_API_URL}/last-assess`)
}

